// extracted by mini-css-extract-plugin
export var container = "_cr-0";
export var icon = "_cr-1";
export var text = "_cr-2";